module.exports = __webpack_public_path__ + "img/loading.694b98ec.svg";